var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "job-insights" },
    [
      _c(
        "section",
        {
          staticClass: "job-insights__pipeline",
          attrs: { "aria-labelledby": "job-pipeline-title" },
        },
        [
          _c("header", { staticClass: "job-insights__header" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "job-insights__filters" }, [
              _vm.canSelectScope
                ? _c("label", { staticClass: "job-insights__filter" }, [
                    _c("span", [_vm._v("Dashboard")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "job-insights__filter-select" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.insightsScope,
                              expression: "insightsScope",
                            },
                          ],
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.insightsScope = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.changeInsightsScope,
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "all" } }, [
                            _vm._v("Alle vacatures"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "personal" } }, [
                            _vm._v("Mijn vacatures"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass: "ak-icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("keyboard_arrow_down")]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("label", { staticClass: "job-insights__filter" }, [
                _c("span", [_vm._v("Vacature filters")]),
                _vm._v(" "),
                _c("div", { staticClass: "job-insights__filter-select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.jobFilter,
                          expression: "jobFilter",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.jobFilter = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "all" } }, [
                        _vm._v("Alle vacatures"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "published" } }, [
                        _vm._v("Enkel gepubliceerde vacatures"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "has-reactions" } }, [
                        _vm._v("Met minstens één sollicitatie"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "ak-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v("keyboard_arrow_down")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c("p", { staticClass: "job-insights__state" }, [
                _vm._v("Pipeline laden…"),
              ])
            : _vm.errorMessage
            ? _c(
                "p",
                {
                  staticClass: "job-insights__state job-insights__state--error",
                },
                [_vm._v(_vm._s(_vm.errorMessage))]
              )
            : _vm.hasPipelineData && _vm.filteredJobs.length
            ? [
                _c("div", { staticClass: "job-insights__table-wrapper" }, [
                  _c("table", { staticClass: "job-insights__table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Vacature"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.statuses, function (status) {
                            return _c(
                              "th",
                              { key: status.id, attrs: { scope: "col" } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(status.title) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.filteredJobs, function (job) {
                        return _c(
                          "tr",
                          { key: job.id },
                          [
                            _c("th", { attrs: { scope: "row" } }, [
                              _vm.canEditJobs
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "job-insights__job-link",
                                      attrs: {
                                        type: "button",
                                        "aria-label": `${job.title} bewerken`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editJob(job.objectId)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(job.title) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "job-insights__job-title" },
                                    [_vm._v(_vm._s(job.title))]
                                  ),
                              _vm._v(" "),
                              job.websiteUrl
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "job-insights__website-link",
                                      attrs: {
                                        href: job.websiteUrl,
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Bekijk op website\n                                    "
                                      ),
                                      _c(
                                        "i",
                                        {
                                          staticClass: "ak-icon",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [_vm._v("open_in_new")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.statuses, function (status) {
                              return _c(
                                "td",
                                { key: status.id },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "job-insights__count-link",
                                      attrs: {
                                        to: _vm.getReactionGridRoute(
                                          job.id,
                                          status.id
                                        ),
                                        "aria-label": `${
                                          job.counts[status.id] || 0
                                        } sollicitaties voor ${
                                          job.title
                                        } met status ${status.title} bekijken`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(job.counts[status.id] || 0) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "job-insights__summary-grid",
                    class: {
                      "job-insights__summary-grid--lead-times-expanded":
                        _vm.showAllLeadTimes,
                    },
                  },
                  [
                    _c(
                      "section",
                      {
                        staticClass: "job-insights__status-overview",
                        attrs: { "aria-labelledby": "status-overview-title" },
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "job-insights__status-list" },
                          _vm._l(_vm.statusSummaries, function (status) {
                            return _c(
                              "li",
                              {
                                key: status.id,
                                staticClass: "job-insights__status-item",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "job-insights__status-name" },
                                  [_vm._v(_vm._s(status.title))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "job-insights__status-track",
                                    attrs: {
                                      role: "progressbar",
                                      "aria-label": `${status.title}: ${status.count} van ${status.totalCount} sollicitaties`,
                                      "aria-valuemin": "0",
                                      "aria-valuemax": "100",
                                      "aria-valuenow": status.percentage,
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "job-insights__status-bar job-insights__status-bar--yellow",
                                      style: { width: `${status.percentage}%` },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  { staticClass: "job-insights__status-count" },
                                  [
                                    _c("span", [_vm._v(_vm._s(status.count))]),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "van " + _vm._s(status.totalCount)
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "job-insights__lead-time-overview",
                        attrs: {
                          "aria-labelledby": "lead-time-overview-title",
                        },
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _vm.loadingLeadTimes
                          ? _c(
                              "p",
                              { staticClass: "job-insights__overview-state" },
                              [_vm._v("Doorlooptijden laden…")]
                            )
                          : _vm.leadTimesErrorMessage
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "job-insights__overview-state job-insights__overview-state--error",
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.leadTimesErrorMessage) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm.leadTimes.length
                          ? _c(
                              "ul",
                              { staticClass: "job-insights__lead-time-list" },
                              _vm._l(_vm.visibleLeadTimes, function (leadTime) {
                                return _c(
                                  "li",
                                  {
                                    key: leadTime.id,
                                    staticClass: "job-insights__lead-time-item",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "job-insights__lead-time-title",
                                      },
                                      [_vm._v(_vm._s(leadTime.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "strong",
                                      {
                                        staticClass:
                                          "job-insights__lead-time-value",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.formatDays(
                                                leadTime.averageDays
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "job-insights__lead-time-caption",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                gemiddeld over " +
                                            _vm._s(leadTime.reactionCount) +
                                            " afgeronde sollicitatie" +
                                            _vm._s(
                                              leadTime.reactionCount === 1
                                                ? ""
                                                : "s"
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasMoreLeadTimes
                          ? _c(
                              "button",
                              {
                                staticClass: "job-insights__lead-time-toggle",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.showAllLeadTimes = !_vm.showAllLeadTimes
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.showAllLeadTimes
                                        ? "Minder tonen"
                                        : "Meer tonen"
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.loadingLeadTimes &&
                        !_vm.leadTimesErrorMessage &&
                        !_vm.leadTimes.length
                          ? _c(
                              "p",
                              { staticClass: "job-insights__overview-state" },
                              [
                                _vm._v(
                                  "\n                        Geen afgeronde sollicitaties voor deze filter.\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ]
            : _vm.hasPipelineData
            ? _c("p", { staticClass: "job-insights__state" }, [
                _vm._v(
                  "\n            Geen vacatures gevonden voor deze filter.\n        "
                ),
              ])
            : _c("p", { staticClass: "job-insights__state" }, [
                _vm._v(
                  "\n            Er zijn nog geen vacatures of sollicitatiestatussen beschikbaar.\n        "
                ),
              ]),
          _vm._v(" "),
          _c(
            "section",
            {
              staticClass: "job-insights__history-overview",
              attrs: { "aria-labelledby": "history-overview-title" },
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _vm.loadingHistory
                ? _c("p", { staticClass: "job-insights__overview-state" }, [
                    _vm._v("Historiek laden…"),
                  ])
                : [
                    _vm.historyErrorMessage
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "job-insights__overview-state job-insights__overview-state--error",
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.historyErrorMessage) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.history.length
                      ? _c(
                          "ol",
                          { staticClass: "job-insights__history-list" },
                          _vm._l(_vm.history, function (entry) {
                            return _c(
                              "li",
                              {
                                key: entry.id,
                                staticClass: "job-insights__history-item",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "job-insights__history-marker",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("i", { staticClass: "ak-icon" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getHistoryActorIcon(
                                            entry.actor.type
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "job-insights__history-content",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "job-insights__history-heading",
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(entry.description)),
                                        ]),
                                        _vm._v(" "),
                                        _c("time", [
                                          _vm._v(
                                            _vm._s(entry.createdAt || "–")
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "job-insights__history-reaction",
                                        attrs: {
                                          to: {
                                            name: "reaction-overview",
                                            params: {
                                              hashId: entry.reactionHashId,
                                            },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(entry.candidateName) +
                                            " · " +
                                            _vm._s(entry.jobTitle) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "job-insights__history-actor",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.getHistoryActorLabel(
                                                entry.actor.type
                                              )
                                            ) +
                                            ": " +
                                            _vm._s(entry.actor.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : !_vm.historyErrorMessage
                      ? _c(
                          "p",
                          { staticClass: "job-insights__overview-state" },
                          [
                            _vm._v(
                              "\n                    Nog geen acties beschikbaar voor dit overzicht.\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
              _vm._v(" "),
              !_vm.loadingHistory && _vm.hasMoreHistory
                ? _c(
                    "button",
                    {
                      staticClass: "job-insights__history-toggle",
                      attrs: {
                        type: "button",
                        disabled: _vm.loadingMoreHistory,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.getHistory(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.loadingMoreHistory
                              ? "Meer laden…"
                              : "Meer tonen"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "childview" } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "job-insights__eyebrow" }, [_vm._v("Pipeline")]),
      _vm._v(" "),
      _c(
        "h1",
        {
          staticClass: "job-insights__title",
          attrs: { id: "job-pipeline-title" },
        },
        [_vm._v("Kandidaten per vacature en status")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "job-insights__intro" }, [
        _vm._v(
          "\n                    Het actuele aantal sollicitaties in elke fase van het selectieproces.\n                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "job-insights__section-heading" }, [
      _c("p", { staticClass: "job-insights__eyebrow" }, [
        _vm._v("Status verdeling"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "status-overview-title" } }, [
        _vm._v("Verdeling per status"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "job-insights__section-heading" }, [
      _c("p", { staticClass: "job-insights__eyebrow" }, [
        _vm._v("Doorlooptijd"),
      ]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "lead-time-overview-title" } }, [
        _vm._v("Per vacature"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "job-insights__section-heading" }, [
      _c("p", { staticClass: "job-insights__eyebrow" }, [_vm._v("Activiteit")]),
      _vm._v(" "),
      _c("h2", { attrs: { id: "history-overview-title" } }, [
        _vm._v("Historiek van acties"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }